import { ORDER_METHODS } from '../../../../services/exports/Constants';

export default {
  order_methods: {
    [ORDER_METHODS.ON_SITE]: 'pedido à mesa',
    [ORDER_METHODS.PICKUP]: 'takeaway',
    [ORDER_METHODS.DELIVERY]: 'entrega',
  },
  errors: {
    draft_validation_failed: 'Por favor, complete a sua morada de entrega antes de continuar.',
  },
};
